// apps/web/src/components/landing-v2/proofs/PullFlipProof.tsx
/** Theme 01 / Pull a card — animated card-flip loop.
 *  Reference: handoff `unauth/landing-v2-show.html` § .mm-pullflip.
 *  The deck stack sits behind the flipping card; the front face
 *  rotates in via the `.landing-v2-flip` keyframe in landing-v2.css. */
export function PullFlipProof() {
  return (
    <div
      className="absolute inset-0 flex items-center justify-center"
      style={{
        background:
          'radial-gradient(ellipse at center, var(--violet-bg), transparent 60%)',
      }}
    >
      <div
        className="relative aspect-[2/3] w-[38%]"
        style={{ perspective: '1000px' }}
      >
        {/* Back-of-deck stack (decorative, no flip) */}
        <div className="pointer-events-none absolute inset-0">
          <span
            className="absolute inset-0 rounded-lg border border-hairline"
            style={{
              transform: 'translate(-8px, 4px) rotate(-3deg)',
              opacity: 0.55,
              background:
                'radial-gradient(circle at 50% 30%, color-mix(in oklab, var(--color-gold-light-legacy) 16%, transparent), transparent 50%), radial-gradient(circle at 50% 70%, color-mix(in oklab, var(--color-astral-violet) 28%, transparent), transparent 60%), linear-gradient(180deg, var(--color-deep-purple), var(--color-midnight))',
            }}
          />
          <span
            className="absolute inset-0 rounded-lg border border-hairline"
            style={{
              transform: 'translate(8px, 4px) rotate(3deg)',
              opacity: 0.55,
              background:
                'radial-gradient(circle at 50% 30%, color-mix(in oklab, var(--color-gold-light-legacy) 16%, transparent), transparent 50%), radial-gradient(circle at 50% 70%, color-mix(in oklab, var(--color-astral-violet) 28%, transparent), transparent 60%), linear-gradient(180deg, var(--color-deep-purple), var(--color-midnight))',
            }}
          />
        </div>

        {/* Flipping card */}
        <div
          className="landing-v2-flip absolute inset-0 rounded-lg"
          style={{ transformStyle: 'preserve-3d' }}
        >
          {/* Back face */}
          <div
            className="absolute inset-0 flex items-center justify-center overflow-hidden rounded-lg border border-hairline"
            style={{
              backfaceVisibility: 'hidden',
              background:
                'radial-gradient(circle at 50% 30%, color-mix(in oklab, var(--color-gold-light-legacy) 20%, transparent), transparent 50%), radial-gradient(circle at 50% 70%, color-mix(in oklab, var(--color-astral-violet) 30%, transparent), transparent 60%), linear-gradient(180deg, var(--color-deep-purple), var(--color-midnight))',
            }}
          >
            <span
              className="font-display text-2xl"
              style={{ color: 'color-mix(in oklab, var(--color-gold-light-legacy) 45%, transparent)' }}
            >
              ✦
            </span>
          </div>

          {/* Front face — the revealed card */}
          <div
            className="absolute inset-0 overflow-hidden rounded-lg border border-hairline"
            style={{
              backfaceVisibility: 'hidden',
              transform: 'rotateY(180deg)',
            }}
          >
            <img
              src="/cards/the-star.webp"
              alt=""
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
